import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import Img from "gatsby-image";
import Navigation from "./navigation";
import { toKebabCase } from "../helpers";
import ImgGallery from "../components/gallery";
// import JustComments from "gatsby-plugin-just-comments";

import style from "../styles/post.module.css";

const Post = ({
  title,
  date,
  path,
  coverImage,
  author,
  excerpt,
  tags,
  gallerimages,
  html,
  previousPost,
  nextPost,
}) => {
  const previousPath = previousPost && previousPost.frontmatter.path;
  const previousLabel = previousPost && previousPost.frontmatter.title;
  const nextPath = nextPost && nextPost.frontmatter.path;
  const nextLabel = nextPost && nextPost.frontmatter.title;

  return (
    <div className={style.post}>
      <div className={style.postContent}>
        <h1 className={style.title}>
          {excerpt ? <Link to={path}>{title}</Link> : title}
        </h1>
        <div className={style.meta}>
          {date} {author && <>— Written by {author}</>}
          {tags ? (
            <div className={style.tags}>
              {tags.map(tag => (
                <Link to={`/tag/${toKebabCase(tag)}/`} key={toKebabCase(tag)}>
                  <span className={style.tag}>#{tag}</span>
                </Link>
              ))}
            </div>
          ) : null}
        </div>

        {coverImage && (
          <Img
            fluid={coverImage.childImageSharp.fluid}
            className={style.coverImage}
          />
        )}

        {excerpt ? (
          <>
            <p>{excerpt}</p>
            <Link to={path} className={style.readMore}>
              Read more →
            </Link>
          </>
        ) : (
          <>
            <div dangerouslySetInnerHTML={{ __html: html }} />

            {gallerimages && <ImgGallery images={gallerimages} />}
            {/* {path !== "/about" && path !== "/changelog" &&
            <div className={style.comments}>
              <hr/>
              <JustComments
                recaptcha={false}
                hideattribution={true}
                enableemailnotifications={true}
                apikey="71fffec7-2d41-4b9f-9d10-de6a5f74b5f5"
              />
            </div>
            } */}
            {path !== "/about" && path !== "/changelog" &&
            <Navigation
              previousPath={previousPath}
              previousLabel={previousLabel}
              nextPath={nextPath}
              nextLabel={nextLabel}
            />
          }
          </>
        )}
      </div>
    </div>
  );
};

Post.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  path: PropTypes.string,
  coverImage: PropTypes.object,
  author: PropTypes.string,
  excerpt: PropTypes.string,
  html: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  gallerimages: PropTypes.arrayOf(PropTypes.object),
  previousPost: PropTypes.object,
  nextPost: PropTypes.object,
};

export default Post;
